import { Axios } from "../axios";
import { getAuthData } from "../../pages/remittance-beta/api/remittanceApi";

export const getFeatureSet = async () => {
  const { token } = getAuthData();
  return await Axios.get("/remit/config/feature-set", {
    headers: {
      Authorization: token,
    },
  });
};
